import motards from '@amo/core/assets/images/AMO_Icons/Tout-motards.svg';
import cross from '@amo/core/assets/images/produits/icon_cross.svg';
import moto from '@amo/core/assets/images/produits/icon_moto.svg';
import quad from '@amo/core/assets/images/produits/icon_quad.svg';
import scooter from '@amo/core/assets/images/produits/icon_scooter.svg';
import { Question } from '@amo/core/components/containers';
import { Radio } from '@amo/core/components/forms';
import { syncUsageVehiculeWithType } from '@amo/core/utils/functions';
import _ from 'lodash';
import { Field } from 'redux-form';
import Swal from 'sweetalert2';
import {getTranslation} from "@amo/core/utils/functions.js";

const TypeVehicule = (props) => {
    const { nextQuestion, data, changeValue, reset, apporteur1, analyticsSetEvent, dejaClientRefresh } = props;

    const changeVehicule = (typeVehicule) => {
        if (typeVehicule !== _.get(data, 'typeVehicule') && _.get(data, 'typeVehicule') !== undefined) {
            Swal.fire({
                icon: 'warning',
                title: getTranslation("vehicle.changeVehicle.title"),
                html: getTranslation("vehicle.changeVehicle.html"),
                confirmButtonText: getTranslation("vehicle.changeVehicle.confirmButtonText"),
                showCancelButton: true,
                cancelButtonText: getTranslation("vehicle.changeVehicle.cancelButtonText"),
            }).then((result) => {
                if (result.isConfirmed) {
                    reset('devis-direct');
                    analyticsSetEvent({event: 'changeVehicle'});
                    selectTypeVehicule(typeVehicule);
                }
            });
        } else {
            selectTypeVehicule(typeVehicule);
        }
    };

    const selectTypeVehicule = (typeVehicule) => {
        switch (typeVehicule) {
            case 'moto':
            case 'scooter':
                changeValue('DemandeTarif[Vehicule][VehiculeImmatricule]', '1');
                break;
            case '50':
                changeValue('cylindreeVehicule', '50');
                changeValue('DemandeTarif[Vehicule][VehiculeImmatricule]', '1');
                break;
            default:
                break;
        }

        syncUsageVehiculeWithType(changeValue, _.get(data, 'typeVehicule'), typeVehicule);

        if(_.get(data, 'typeVehicule') === undefined || typeVehicule !== _.get(data, 'typeVehicule')) {
            dejaClientRefresh({typeProduit: typeVehicule});
        }

        changeValue('typeVehicule', typeVehicule);
    };

    return (
        <Question asFieldset required icon={motards} title={getTranslation("vehicle.vehicleType")}>
            <div className={'row justify-content-center mt-2'}>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'typeVehicule'}
                        value={'moto'}
                        label={getTranslation("moto")}
                        onChange={(e) => {
                            e.preventDefault();
                            changeVehicule(e.target.value);
                        }}
                        icon={moto}
                    />
                </div>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'typeVehicule'}
                        value={'scooter'}
                        label={getTranslation("scooter")}
                        onChange={(e) => {
                            e.preventDefault();
                            changeVehicule(e.target.value);
                        }}
                        icon={scooter}
                    />
                </div>
                {apporteur1.codeBelair !== 809466 && (
                    <>
                        <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                            <Field
                                component={Radio}
                                type={'radio'}
                                name={'typeVehicule'}
                                value={'50'}
                                label={getTranslation("cyclo")}
                                onChange={(e) => {
                                    e.preventDefault();
                                    changeVehicule(e.target.value);
                                }}
                                icon={scooter}
                            />
                        </div>
                        <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                            <Field
                                component={Radio}
                                type={'radio'}
                                name={'typeVehicule'}
                                value={'quad'}
                                label={getTranslation("quad")}
                                onChange={(e) => {
                                    e.preventDefault();
                                    changeVehicule(e.target.value);
                                }}
                                icon={quad}
                            />
                        </div>
                        <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                            <Field
                                component={Radio}
                                type={'radio'}
                                name={'typeVehicule'}
                                value={'verte'}
                                label={getTranslation("motoVerte")}
                                onChange={(e) => {
                                    e.preventDefault();
                                    changeVehicule(e.target.value);
                                }}
                                icon={cross}
                            />
                        </div>
                    </>
                )}
            </div>

            <button
                className={`btn btn-primary btn-arrow mt-4 ${!data?.typeVehicule && 'disabled'}`}
                onClick={() => nextQuestion()}
            >
                {getTranslation('continue')}
            </button>
        </Question>
    );
};

export default TypeVehicule;
